var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33334 13.3332C5.33334 8.30486 5.33334 5.7907 6.89543 4.2286C8.45753 2.6665 10.9717 2.6665 16 2.6665C21.0283 2.6665 23.5425 2.6665 25.1046 4.2286C26.6667 5.7907 26.6667 8.30486 26.6667 13.3332V15.9998C26.6667 21.0282 26.6667 23.5423 25.1046 25.1044C23.5425 26.6665 21.0283 26.6665 16 26.6665C10.9717 26.6665 8.45753 26.6665 6.89543 25.1044C5.33334 23.5423 5.33334 21.0282 5.33334 15.9998V13.3332Z",
    stroke: "#7A990E",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33334 17.3335H26.6667",
    stroke: "#7A990E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 21.3335H22.6667",
    stroke: "#7A990E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33334 21.3335H11.3333",
    stroke: "#7A990E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 26V28C8 28.7364 8.59695 29.3333 9.33333 29.3333H11.3333C12.0697 29.3333 12.6667 28.7364 12.6667 28V26.6667",
    stroke: "#7A990E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26V28C24 28.7364 23.403 29.3333 22.6667 29.3333H20.6667C19.9303 29.3333 19.3333 28.7364 19.3333 28V26.6667",
    stroke: "#7A990E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 12H28C28.7364 12 29.3333 12.597 29.3333 13.3333V14.6667C29.3333 15.0863 29.1357 15.4815 28.8 15.7333L26.6667 17.3333",
    stroke: "#7A990E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 12H4C3.26362 12 2.66666 12.597 2.66666 13.3333V14.6667C2.66666 15.0863 2.86426 15.4815 3.2 15.7333L5.33333 17.3333",
    stroke: "#7A990E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6.6665H6",
    stroke: "#7A990E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/Bus.476aa27fb5b3abb3ec9644b8979d766d.svg";
export { ForwardRef as ReactComponent };